import React, { Component } from 'react';
import { userLogout } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';

class LogoutConfirmationModal extends Component {
  componentDidMount() {
    try {
      this.logoutConfirmModal = new window.bootstrap.Modal(window.$('#logoutConfirmationModal'), {});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLogout = async () => {
    try {
      await userLogout();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="logoutConfirmationModal"
        tabIndex="-1" aria-labelledby="logoutConfirmationModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="logoutConfirmationModalLabel">Logout</h5>
              <p>To select this team, you need to log in again.</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" onClick={this._onLogout} data-bs-dismiss="modal">Ok</button>
                </div>
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LogoutConfirmationModal;
